// No imports, so `npm test` (node:test) can load it without the Next toolchain.

/**
 * The /emailUser keys to read for an email, in order: the trimmed, lowercased
 * email first, then the email as given, which is how entries were keyed
 * before keys were lowercased.
 * @param {string} email
 * @returns {string[]} base64 keys
 */
function emailUserKeys(email) {
  // An empty key would read /emailUser itself, which is denied
  return [...new Set([email.trim().toLowerCase(), email])]
    .filter((key) => key.trim())
    .map((key) => Buffer.from(key).toString('base64'));
}

module.exports = { emailUserKeys };
